import {FilterValue} from "antd/es/table/interface";
import {ArrayDataOptions, FilterOption, Maybe} from "../generated/graphql";

export const updateFilters = ({filters, options, table}: {filters: Record<string, FilterValue | null>; options?: Maybe<ArrayDataOptions>; table: string}) => {
    const currentFilters = options?.filter ?? [];
    // Starten mit den aktuellen Filtern, entfernen aber jene, die im neuen 'filters' Objekt enthalten sind (um sie zu aktualisieren)
    let updatedFilters: Array<FilterOption> = [...currentFilters];

    // FIX: Verwende die übergebenen 'filters' statt 'currentFilters' zu iterieren
    Object.entries(filters).forEach(([column, values]) => {
        // FIX: Wenn Ant Design null übergibt (weil filteredValue nicht gesetzt ist),
        // den existierenden Filter BEIBEHALTEN statt zu entfernen.
        // Dies passiert z.B. bei Seitenwechsel für Spalten ohne filteredValue.
        if (values === null || values === undefined) {
            return; // Existierenden Filter beibehalten
        }

        // Entferne existierenden Filter für diese Spalte
        updatedFilters = updatedFilters.filter((f) => f.column !== column);

        // Wenn Werte vorhanden sind, füge neuen Filter hinzu
        // Leeres Array bedeutet: Filter wurde explizit gelöscht
        if (values.length > 0 && values[0] !== null) {
            updatedFilters.push({
                table,
                column,
                values: values as Array<string>,
            });
        }
    });

    return updatedFilters;
};
